import {Flag} from 'platform/components';
import {HStack, Show, Text} from 'platform/foundation';

import {ReactNode} from 'react';

import {isString} from 'ramda-adjunct';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

/**
 * Builds a `formatOptionLabel` renderer for contact-person choice fields that
 * appends a green "Primary contact" flag to whichever option matches one of the
 * given primary contact ids.
 */
export const getContactPersonPrimaryOptionFormatter =
  (primaryContactIds: ReadonlySet<string>) =>
  (option: {label?: string | Nullish; value?: string | number | Nullish}): ReactNode => (
    <HStack spacing={2} align="center">
      <Text size="small">{option.label}</Text>
      <Show
        when={isString(option.value) && primaryContactIds.has(option.value)}
        whenFeatureEnabled={featureFlags.CUSTOMER_PRIMARY_CONTACT}
      >
        <Flag
          size="small"
          colorScheme="green"
          label={i18n.t('entity.customer.labels.contactPersonsHelperText')}
        />
      </Show>
    </HStack>
  );
